// src/services/autocomplete.service.ts
import { apiGet } from './api';

export type LocationApiSuggestion = {
  // Step 1 (centrals)
  centralId?: string | any;
  // Step 2 (destinations from routes)
  routeId?: string | any;

  description: string | null;
  city: string | null;
  state: string | null;
  coordinates?: any;

  // tu backend ya puede mandar label; si no, lo construimos
  label?: string;
};

export function buildLabel(s: Pick<LocationApiSuggestion, 'description'|'city'|'state'>) {
  const d = s.description || 'Sin descripción';
  const c = s.city || '';
  const st = s.state || '';
  return `${d}, ${c}${st ? `, ${st}` : ''}`.trim();
}

export async function autocompleteOrigin(q: string, signal?: AbortSignal) {
  const v = q.trim();
  if (v.length < 2) return [] as LocationApiSuggestion[];
  return apiGet<LocationApiSuggestion[]>(
    `/routes?origin=${encodeURIComponent(v)}`,
    signal
  );
}

export async function autocompleteDestination(originCity: string, q: string, signal?: AbortSignal) {
  const o = originCity.trim();
  const v = q.trim();
  if (!o || v.length < 2) return [] as LocationApiSuggestion[];
  return apiGet<LocationApiSuggestion[]>(
    `/routes?origin=${encodeURIComponent(o)}&destination=${encodeURIComponent(v)}`,
    signal
  );
}
